module.exports = __webpack_public_path__ + "img/header.09f7a82.jpg";